import React, { Component } from 'react'
import axios from 'axios'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
//import Image from 'react-bootstrap/Image'
import ImageUploading from "react-images-uploading"
import ReactCrop from "./LopiCrop"
import LopiGrid from "./LopiGrid"
import Pagination from "react-js-pagination";
import '../scss/LopiCrop.scss'
import '../scss/LopiHotspots.scss'
import '../scss/LopiGeneral.scss'


export default class LopiContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHideModal: false,
            images: [],
            image_url: "",
            hotspots: [],
            crop: {},
            dummy: 0,
            products: {
                pageSize: 8,
                currentPage: 1,
                active: false,
                found: 0,
                sourceType: 'url',
                sourceUrl: '',
                hits: [{
                    id: 0,
                    image: "",
                    link: "",
                    title: ""
                }] 
            },
            suggestedImages: [],
            imageIsLoading: false,
            croppedImageUrl: ""
        }

        this.handleModalShowHide = this.handleModalShowHide.bind(this)
        this.onFileUploadChange = this.onFileUploadChange.bind(this)
        this.onCropChange = this.onCropChange.bind(this)
        this.onCropComplete = this.onCropComplete.bind(this)
        this.onImageLoaded = this.onImageLoaded.bind(this)
        this.handleHotspotClick = this.handleHotspotClick.bind(this)
        this.showSuggestedImages = this.showSuggestedImages.bind(this)
        this.resetCropandProducts = this.resetCropandProducts.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.getProducts = this.getProducts.bind(this)
        this.handleSimilarProductsClick = this.handleSimilarProductsClick.bind(this)
        
    }

    handleModalShowHide() {
        this.setState({ showHideModal: !this.state.showHideModal })
    }

    onCropChange = (crop, percenCrop) => {
        this.setState({ crop:  percenCrop})
    }

    resetCropandProducts() {
        this.setState({ crop:  {}})
        this.setState({ croppedImageUrl: '' })
        this.setState({ 
            products: { 
                ...this.state.products,
                active: false
            }})
        return false
    }

    onImageLoaded = image => {
        this.imageRef = image
        this.state.mainImage = image

        if (this.state.hotspots.length) {
            this.setState({crop: this.transformCropfromHotspot(this.state.hotspots[0])}) 
            this.getProducts(this.props.client, 'url', this.state.hotspots[0].image, 1, this.state.products.pageSize)
            this.setState({ 
                products: 
                { 
                    ...this.state.products,
                    sourceType: 'url', 
                    sourceUrl: this.state.hotspots[0].image}})
        } else {
            this.getProducts(this.props.client, 'url', this.state.image_url, 1, this.state.products.pageSize)
            this.setState({ 
                products: { 
                    ...this.state.products,
                    sourceType: 'url', 
                    sourceUrl: this.state.image_url
                }})
        }
        
        return false; // Return false when setting crop state in here.

    }

    onFileUploadChange = (imageList, addUpdateIndex) => {
        // data for submit
        this.resetCropandProducts()
        this.setState({images: imageList }) 
        this.setState({image_url: this.state.images[0]["data_url"]})
        this.setState({imageIsLoading: true})
        

        // Create an object of formData 
        const formData = new FormData();

        // Update the formData object 
        formData.append(
            "file", this.state.images[0]["file"]
        )
        formData.append(
            "key", this.props.client
        );

        // Request made to the backend api 
        // Send formData object 

        axios.post("https://api.lopi.ai/v1/upload_detect?file", formData)
            .then((response) => {
                console.log(JSON.stringify(response.data))
                const objects = response.data.objects
                this.setState({ hotspots: objects })
                this.setState({ imageIsLoading: false })
                this.setState({ showHideModal: false })
            }, this)
            .catch((error) => alert(error))
            

    }    

    onCropComplete = (crop, percenCrop) => {
       this.makeClientCrop(crop);
    }

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
          const croppedImageUrl = await this.getCroppedImg(
            this.imageRef,
            crop,
            'newFile.jpeg'
          )
          this.setState({ croppedImageUrl });
        }
      }
    
    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas')
        const scaleX = image.naturalWidth / image.width
        const scaleY = image.naturalHeight / image.height
        canvas.width = crop.width
        canvas.height = crop.height
        const ctx = canvas.getContext('2d')

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height,
        );

        // As Base64 string
        const base64Image = canvas.toDataURL('image/jpeg')

        // As a blob
        /* return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
            blob.name = fileName;
            resolve(blob);
            }, 'image/jpeg', 1);
        });*/
        return base64Image
    }

    getProducts = (key, type, image_url, page, page_size) => {
        // Create an object of formData 
        const formData = new FormData()

        // Update the formData object 
        formData.append("key", key)
        if (type === 'url') { formData.append("url", image_url) }
         else { formData.append("file_base64", image_url) }
        
        formData.append("page", page)
        formData.append("page_size", page_size)

        // Request made to the backend api 
        // Send formData object 

        axios.post("https://api.lopi.ai/v1/vsearch", formData)
            .then((response) => {
                const products = response.data.result
                this.setState( prevState => ({
                    products: {
                        ...prevState.products,
                        active: true,
                        found: products.found,
                        hits: products.hits,
                        pageSize: page_size,
                        sourceType: type,
                        sourceUrl: image_url,
                        currentPage: page                    
                    }
                })) 
            }, this)
            .catch((error) => alert(error))   
    }

    transformCropfromHotspot = hotspot => {
        const mainImage = this.state.mainImage
        const image_width = mainImage.naturalWidth
        const image_height = mainImage.naturalHeight
        const hotspot_top = (hotspot.rect.y0*100)/image_height 
        const hotspot_left = (hotspot.rect.x0*100)/image_width 
        const hotspot_width = (hotspot.rect.x1-hotspot.rect.x0)*100/image_width
        const hotspot_height = (hotspot.rect.y1-hotspot.rect.y0)*100/image_height
        const crop_selected = {
            unit: "%",
            x: hotspot_left,
            y: hotspot_top,
            width: hotspot_width,
            height: hotspot_height
        }
        this.setState({
            products: { 
                ...this.state.products,
                url: hotspot.image
            }
        })
        return crop_selected
    }

    /*getHotspotStyle = hotspot => {
        const mainImage = this.state.mainImage
        const image_width = mainImage.naturalWidth
        const image_height = mainImage.naturalHeight
        const hotspot_top = (hotspot.rect.y0*100)/image_height 
        const hotspot_left = (hotspot.rect.x0*100)/image_width 
        const hotspot_width = (hotspot.rect.x1-hotspot.rect.x0)*100/image_width
        const hotspot_height = (hotspot.rect.y1-hotspot.rect.y0)*100/image_height
    
        return {
          top: `${hotspot_top}%`,
          left: `${hotspot_left}%`,
          width: `${hotspot_width}%`,
          height: `${hotspot_height}%`
        }
    }*/

    getHotspotPreviewStyle = hotspot => {
        const mainImage = this.state.mainImage
        const image_nwidth = mainImage.naturalWidth
        const image_nheight = mainImage.naturalHeight
        const image_width = mainImage.width
        const image_height = mainImage.height
        const hotspot_width = (hotspot.rect.x1-hotspot.rect.x0) * image_width / image_nwidth
        const hotspot_height = (hotspot.rect.y1-hotspot.rect.y0) * image_height / image_nheight
    
        return {
          //top: `${hotspot_top}px`,
          //left: `${hotspot_left}px`,
          width: `${hotspot_width}px`,
          height: `${hotspot_height}px`,
          top: '9px',
          left: '10px'
        }
    }    

    getHotspotWrapperStyle = hotspot => {
        const mainImage = this.state.mainImage
        const image_width = mainImage.naturalWidth
        const image_height = mainImage.naturalHeight
        const hotspot_top = (hotspot.rect.y0 + (hotspot.rect.y1-hotspot.rect.y0)/2)*100/image_height
        const hotspot_left = (hotspot.rect.x0 + (hotspot.rect.x1-hotspot.rect.x0)/2)*100/image_width
    
        return {
          top: `${hotspot_top}%`,
          left: `${hotspot_left}%`
        }
    }      
    
    handleHotspotClick = (e,hotspot) => {
        this.setState({croppedImageUrl: ''})
        this.setState({crop: this.transformCropfromHotspot(hotspot)})
        

        //axios post with hotspot url to display products
        this.getProducts(this.props.client, 'url', hotspot.image, 1, this.state.products.pageSize)
        this.setState({ 
            products: { 
                ...this.state.products,
                sourceType: 'url', 
                sourceUrl: hotspot.image
            }
        })
    }

    showSuggestedImages() {
        // Create an object of formData 
        const formData = new FormData()

        formData.append(
            "key", this.props.client
        )

        axios.post("https://api.lopi.ai/v1/suggest_images", formData)
            .then(response => {
                const images = response.data
                this.setState({ suggestedImages: images })
            })
        .catch(error => {
            console.log(error)
        })

    }

    getBase64Image(imgUrl, callback) {
        var img = new Image()
        // onload fires when the image is fully loadded, and has width and height     
        // set attributes and src 
        img.setAttribute('crossOrigin', 'Anonymous')
        //img.src = 'https://secure.img1-ag.wfcdn.com/im/17699499/c_crop-h750-w750%5Eresize-h750-w750%5Ecompr-r85/4744/47442992/Soak+It+Up.jpg'
        img.src = imgUrl

        img.onload = function(){
            var canvas = document.createElement("canvas")
            canvas.width = img.width
            canvas.height = img.height
            var ctx = canvas.getContext("2d")
            ctx.drawImage(img, 0, 0)
            var dataURL = canvas.toDataURL("image/png")
            callback(dataURL) // the base64 string
          }
    }


    handleImageSuggestClick = imageUrl => {
        this.setState({ imageIsLoading: true })
        this.resetCropandProducts();

        const comp = this
        this.getBase64Image(imageUrl, function(dataURL) {
            comp.setState({image_url: dataURL})
            return false
         })

        // Create an object of formData 
        const formData = new FormData()

        // Update the formData object 
        formData.append(
            "url", imageUrl
        )
        formData.append(
            "key", this.props.client
        )

        // Request made to the backend api 
        // Send formData object 


        axios.post("https://api.lopi.ai/v1/upload_detect", formData)
            .then((response) => {
                console.log(JSON.stringify(response.data))
                const objects = response.data.objects
                console.log(objects)
                this.setState({ hotspots: objects })
                this.setState({ imageIsLoading: false })
                this.setState({ showHideModal: false })
                
                
            }, this)
            .catch((error) => alert(error))
    }

    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`)
        
        this.getProducts(this.props.client, this.state.products.sourceType, this.state.products.sourceUrl, pageNumber, this.state.products.pageSize)
    }
    
    handleSimilarProductsClick() {
        this.getProducts(this.props.client, 'file_base64', this.state.croppedImageUrl, 1, this.state.products.pageSize)
    }

    render() {
        return (
            <>
                <Container fluid>
                    <Row>
                        <Col>
                            <Button className="LopiUploadButton" size="lg" onClick={() => this.handleModalShowHide()}>
                                Search with Photo
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            {!this.state.imageIsLoading && 
                            <>
                            <div className="ReactCrop-wrapper">
                                <ReactCrop src={this.state.image_url} onImageLoaded={this.onImageLoaded} crop={this.state.crop} onChange={this.onCropChange} onComplete={this.onCropComplete} hotspots={this.state.hotspots}/>  
                                {this.state.mainImage && this.state.hotspots.map((hotspot, index) => (
                                     <button key={index} 
                                     className="LopiHotspotWrapper"
                                     style={this.getHotspotWrapperStyle(hotspot)}>
                                         <div className="LopiHotspotIcon" onClick={(e) => this.handleHotspotClick(e,hotspot)}></div>
                                         <div className="LopiHotspotPreview" style={this.getHotspotPreviewStyle(hotspot)}></div>

                                 </button>
                                   
                                ))}
                            </div> 
                            <p className="LopiSimilarButton">
                            {this.state.croppedImageUrl && !this.state.imageIsLoading &&
                                <Button variant="primary" onClick={this.handleSimilarProductsClick}>Find Similar Items</Button>
                            }
                            </p>
                            
                             </>}
                        </Col>
                        <Col md={8}>
                            {this.state.products.active && 
                            <>
                                 <LopiGrid products={this.state.products} />
                                 {this.state.products.hits.length > 0 && <Pagination
                                    activePage={this.state.products.currentPage}
                                    itemsCountPerPage={this.state.products.pageSize}
                                    totalItemsCount={this.state.products.found}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    />
                                 }
                            </>
                            }
                        </Col>
                    </Row>
                </Container>

                <Modal show={this.state.showHideModal} onHide={() => this.handleModalShowHide()} onShow={this.showSuggestedImages}>
                    <Modal.Header closeButton>
                        <Modal.Title>Search with Photo</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <ImageUploading
                            value={this.state.images}
                            onChange={this.onFileUploadChange}
                            dataURLKey="data_url"
                            acceptType={['jpg', 'jpeg', 'tiff', 'png', 'heic']}
                        >
                            {({
                                imageList,
                                onImageUpload,
                                onImageRemoveAll,
                                onImageUpdate,
                                onImageRemove,
                                isDragging,
                                dragProps,
                            }) => (
                                // write your building UI
                                
                                    <div
                                        className="LopiUpoadContainer"
                                        style={isDragging ? { color: "red" } : null}
                                        onClick={onImageUpload} 
                                        {...dragProps}
                                    >
                                        {!this.state.imageIsLoading && <div className="LopiUploadText">Click or Drop Photo here</div>}
                                        {this.state.imageIsLoading && <Spinner className="LopiSpinner" animation="border" role="status"><span className="sr-only">Loading...</span></Spinner>}
                                    </div>
                                
                            )}
                        </ImageUploading>
                    </Modal.Body>
                    <Modal.Footer>
                        <Container>
                            <h6>Choose from our suggestions</h6>
                            <Row>
                                {this.state.suggestedImages.map((imageUrl, index) => (
                                    <Col sm={4} key={index}>
                                        <img alt="" src={imageUrl} key={index} className="lopiThumb" onClick={() => this.handleImageSuggestClick(imageUrl)} /> 
                                    </Col> 
                                ))}
                            </Row>
                        </Container>
                    </Modal.Footer>
                </Modal>

            </>
        )
    }
}